import React,{Component} from 'react';
import {auth} from '../services/firebase';
import {db} from '../services/firebase';

import '../css/chat.css';


export default class Chat extends Component{
    constructor(props){
        super(props);
        this.state = {
            user: auth().currentUser,
            chats: [],
            content:'',
            readError:null,
            writeError:null
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.myRef = React.createRef();
    }
    
    
    async componentDidMount() {
        this.setState({ readError: null });
        let chatArea = this.myRef.current;
        try {
          db.ref("chats").on("value", snapshot => {
            let chats = [];
            snapshot.forEach((snap) => {
              chats.push(snap.val());
            });
            this.setState({ chats });
            chatArea.scrollBy(0, chatArea.scrollHeight);
          });
        } catch (error) {
          this.setState({ readError: error.message });
        }
      }

    handleChange(event){
        event.preventDefault();
        this.setState({
            content:event.target.value
        });
    }

    async handleSubmit(event){
        event.preventDefault();
        const chatArea = this.myRef.current;
        this.setState({writeError:null});
        try{
            await db.ref("chats").push({
                content:this.state.content,
                timestamp: Date.now(),
                email: this.state.user.email
            });
            this.setState({ content:''});
            chatArea.scrollBy( 0, chatArea.scrollHeight);
        } catch (error) {
            this.setState({ writeError : error.massage });
        }
    }
    render(){
        return(
            <div class="mainPageContainer">
            
            <div class="chatContainer">
            <div class="chatUserDash">
            <button class="chatSignOut" onClick={() => auth().signOut()}>SignOUT</button>
                <div class="userName">
                    Logged in as: AGENT <strong>{this.state.user.email}</strong>
                </div>
                </div>
                <div className="chats" ref={this.myRef}>
                    {this.state.chats.map(chat => {
                        let emailU = chat.email;
                        if(chat.email === this.state.user.email){
                            return <p class="currentUserChat" key={chat.timestamp}>Message: {chat.content}<span>{emailU ?  emailU : "N/A"} {new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(chat.timestamp)}</span></p>
                        }
                            return <p key={chat.timestamp}>Message: {chat.content}<span>{emailU ?  emailU : "N/A"} {new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(chat.timestamp)}</span></p>
                    })}
                </div>
                {/* {# message form #} */}
                <form class="chatForm" onSubmit={this.handleSubmit}>
                    <input onChange={this.handleChange} value={this.state.content}></input>
                    {this.state.error ? <p>{this.state.writeError}</p> : null}
                    <button type="submit">Transmit</button>
                </form>
                
                </div>
            </div>
        );
    }

}